import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { MobileAppTabBar } from './MobileAppTabBar';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      const targetId = hash.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        const timer = setTimeout(() => {
          const el = document.getElementById(targetId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        }, 150);
        return () => clearTimeout(timer);
      }
    }
  }, [pathname, hash]);

  return null;
}

export function Layout() {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith('/admin');
  const isDedicatedWorkspaceOrPortal =
    isAdminRoute ||
    pathname.startsWith('/checkin') ||
    pathname.startsWith('/counter/perks') ||
    pathname.startsWith('/vendor/perks') ||
    pathname.startsWith('/my-iiab') ||
    pathname.startsWith('/exhibitor-portal') ||
    pathname.startsWith('/portal/exhibitor');

  return (
    <div className="min-h-screen bg-[#F8F9F6] text-slate-800 flex flex-col font-sans selection:bg-[#0A3D27] selection:text-white pb-16 md:pb-0">
      <ScrollToTop />
      {!isDedicatedWorkspaceOrPortal && <Navbar />}
      <main
        className={`flex-1 w-full ${
          isAdminRoute
            ? 'max-w-none p-0'
            : 'max-w-7xl mx-auto px-4 sm:px-6 py-6'
        }`}
      >
        <Outlet />
      </main>
      {!isDedicatedWorkspaceOrPortal && <Footer />}
      <MobileAppTabBar />
    </div>
  );
}

export default Layout;
